import { Accordion, AccordionDetails, Grid2 } from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import React from "react";
import { statisticsStyles } from "./styles";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { AccordionSummary } from "@mui/material";
import TagsSearchForm from "./TagSearchForm";
import TagsChart from "./TagsChart";

class Tags extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            (<Grid2 container direction={"column"} spacing={3}>
                <Grid2 size={12}>
                    <Accordion defaultExpanded>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>Search</AccordionSummary>
                        <AccordionDetails>{<TagsSearchForm />}</AccordionDetails>
                    </Accordion>
                </Grid2>
                <Grid2 size={12}>
                    <TagsChart />
                </Grid2>
            </Grid2>)
        );
    }
}

export default withStyles(statisticsStyles)(Tags);
